import React, { useState, useRef, useEffect } from 'react';
import { Badge } from './ui/badge';

const MultiSelectFilter = ({ label, options, selected, onChange, testId }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggle = (val) => {
    onChange(selected.includes(val) ? selected.filter(v => v !== val) : [...selected, val]);
  };

  const clearAll = (e) => { e.stopPropagation(); onChange([]); };

  return (
    <div className="relative" ref={ref}>
      <button type="button" onClick={() => setOpen(!open)}
        className={`h-10 rounded-md border bg-background px-3 py-2 text-sm flex items-center gap-1.5 min-w-[120px] justify-between hover:bg-gray-50 transition-colors ${selected.length > 0 ? 'border-blue-400 bg-blue-50/50' : 'border-input'}`}
        data-testid={testId}>
        <span className="truncate max-w-[120px]">{label}</span>
        {selected.length > 0 && (
          <Badge className="bg-blue-600 text-white text-xs px-1.5 py-0 h-5 min-w-[20px] flex items-center justify-center" onClick={clearAll}>
            {selected.length}
          </Badge>
        )}
        <svg className={`w-3.5 h-3.5 text-gray-500 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {open && (
        <div className="absolute top-full left-0 mt-1 bg-white border rounded-lg shadow-lg z-50 min-w-[200px] max-h-64 overflow-y-auto" data-testid={`${testId}-dropdown`}>
          {options.length > 5 && (
            <div className="sticky top-0 bg-white border-b px-3 py-2 flex justify-between">
              <button type="button" className="text-xs text-blue-600 hover:underline" onClick={() => onChange(options.map(o => o.value))}>Select All</button>
              <button type="button" className="text-xs text-gray-500 hover:underline" onClick={() => onChange([])}>Clear</button>
            </div>
          )}
          {options.map(opt => (
            <label key={opt.value} className="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 cursor-pointer text-sm" data-testid={`${testId}-opt-${opt.value}`}>
              <input type="checkbox" checked={selected.includes(opt.value)} onChange={() => toggle(opt.value)}
                className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
              <span className="truncate">{opt.label}</span>
            </label>
          ))}
          {options.length === 0 && <p className="px-3 py-2 text-xs text-gray-400">No options</p>}
        </div>
      )}
    </div>
  );
};

export default MultiSelectFilter;
